import type { PaginationResultDto } from '@bondsports/types';

/**
 * `getNextPageParam` for `useDebouncedInfiniteQuery`. Returns the next page number, or
 * `undefined` when the response did not include pagination metadata or the cursor has
 * reached the final page.
 *
 * Explicit `=== undefined` checks (instead of truthiness) keep the helper safe for any
 * future 0-indexed pagination contract — `currentPage === 0` is a valid cursor, not a
 * "missing meta" signal.
 */
export const getNextPage = <T>(lastPage: PaginationResultDto<T> | undefined): number | undefined => {
	const meta = lastPage?.meta;
	if (meta?.currentPage === undefined || meta?.totalPages === undefined) return undefined;
	return meta.currentPage === meta.totalPages ? undefined : meta.currentPage + 1;
};
